module.exports = __webpack_public_path__ + "img/insurance-quotes.a1e00cf0.svg";